import { createContext, type ReactNode, useEffect, useState } from 'react'

import { ProfileType } from '@/enum/profile-type'

interface AuthContextType {
  signed: boolean
  nameUser: string | null
  email: string | null
  token: string | null
  perfilImage: string | null
  userId: string | null
  userProfiles: number[] | null
  typeRegistration: string | null
  currentProfile: ProfileType | null
  setCurrentProfile: (profile: ProfileType) => void
}

export const AuthContext = createContext<AuthContextType>({} as AuthContextType)

export default function AuthProvider({ children }: { children: ReactNode }) {
  const [currentProfile, setCurrentProfile] = useState<ProfileType | null>(null)

  const nameUser = sessionStorage.getItem('name')
  const email = sessionStorage.getItem('email')
  const token = sessionStorage.getItem('token')
  const perfilImage = sessionStorage.getItem('perfil_image')
  const userId = sessionStorage.getItem('user_id')
  const typeRegistration = sessionStorage.getItem('type_registration')
  const defaultProfile = sessionStorage.getItem('default_profile')
  const profiles = sessionStorage.getItem('user_profiles')
  const userProfiles: number[] | null = profiles ? JSON.parse(profiles) : null

  useEffect(() => {
    if (currentProfile === null && userProfiles && userProfiles.length > 0) {
      if (defaultProfile && userProfiles.includes(Number(defaultProfile))) {
        setCurrentProfile(Number(defaultProfile))
      } else {
        setCurrentProfile(userProfiles[0])
      }
    }
  }, [currentProfile, userProfiles, defaultProfile])

  return (
    <AuthContext.Provider
      value={{
        signed: !!token,
        nameUser,
        email,
        token,
        perfilImage,
        userId,
        userProfiles,
        typeRegistration,
        currentProfile,
        setCurrentProfile,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
